import { returnErrors } from "@/utils/returnErrors";
import { notifyError } from "@/utils/notifier.js";

export function handleApiError(error: any, customMessage?: string): void {
  const errorMessage: any = returnErrors(error);
  notifyError(
    false,
    customMessage || errorMessage,
    "negative",
    "report_problem",
  );
}
